const users = {
    name: 'Users/UsersPage',
    path: '/users',
    icon: 'mdi-account-group',
    label: 'Users'
};
const kaleadicals = {
    name: 'Kaleadicals/KaleadicalsPage',
    path: '/kaleadicals',
    icon: 'mdi-shape',
    label: 'Kaleadicals'
};

const profile = {
    name: 'Dashboard/UserProfilePage',
    path: '/profile',
    icon: 'mdi-account',
    label: 'Profile'
};

export const superAdmin = _ => {
    return [
        kaleadicals,
    ];
};

export const admin = _ => {
    return [
        kaleadicals,
        users
    ];
};

export const bottomNavRoutes = _ => {
    return [
        profile,
    ];
};
